import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';
import getCardinalPointFromStoneId from '../helpers/getCardinalPointFromStoneId';
import getDomain from '../helpers/getDomain';
import WallImage from './WallImage';
import PdfButton from './PdfButton';

export default function CertificateDownloadBox(props) {
  const [emailVisibility, setEmailVisibility] = useState(false);
  const [emailAlert, setEmailAlert] = useState(null);
  const [documentInfo, updateDocumentInfo] = useState(null);
  const emailField = useRef(null);

  useEffect(() => {
    axios
      .get(
        getDomain() +
          `/api/order/${props.orderId}/stone/${props.stoneId}/certificate`
      )
      .then((response) => {
        updateDocumentInfo({
          name: response.data.name,
          stoneId: props.stoneId,
          wall: getCardinalPointFromStoneId(props.stoneId),
        });
      })
      .catch((error) => {
        updateDocumentInfo(null);

        if (error.response) {
          console.error(error.response.data);
        } else if (error.request) {
          console.error(error.request);
        } else {
          console.error('Error', error.message);
        }
      });
  }, [props.orderId, props.stoneId]);

  const handleCheckboxChange = () => {
    if (emailVisibility === true) {
      setEmailVisibility(false);
    } else {
      setEmailVisibility(true);
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (emailField.current.checkValidity()) {
      axios
        .post(
          getDomain() +
            `/api/order/${props.orderId}/stone/${props.stoneId}/send-certificate`,
          [emailField.current.value]
        )
        .then((response) => {
          console.log(response);

          setEmailAlert({
            status: 'success',
            text: 'Sent!',
          });
        })
        .catch((error) => {
          if (error.response) {
            console.error(error.response.data);
          } else if (error.request) {
            console.error(error.request);
          } else {
            console.error(error.message);
          }

          setEmailAlert({
            status: 'danger',
            text: 'There was an error',
          });
        });
    }
  };

  return documentInfo !== null ? (
    <div className="bg-white pt-4 pl-4 pr-4 pb-0 mb-3 mb-md-4">
      <div className="row">
        <div className="col-md-5 mb-4">
          <WallImage stoneId={props.stoneId} />
        </div>

        <div className="col-md-7 d-flex flex-column">
          <div className="row mb-2">
            <div className="col-4 font-weight-bold">Stone:</div>
            <div className="col-8">{props.stoneId}</div>
          </div>

          <div className="row mb-2">
            <div className="col-4 font-weight-bold">Wall:</div>
            <div className="col-8">
              The {getCardinalPointFromStoneId(props.stoneId)} Side
            </div>
          </div>

          {documentInfo.name ? (
            <div className="row mb-2">
              <div className="col-4 font-weight-bold">Sponsor name:</div>
              <div className="col-8">{documentInfo.name}</div>
            </div>
          ) : null}

          <div className="row mb-2">
            <div className="col-4 font-weight-bold">Share:</div>
            <div className="col-8">
              <a
                href={
                  'https://twitter.com/share?text=@HRP_palaces Just sponsored a stone at the White Tower&url=' +
                  window.location.protocol +
                  '//' +
                  window.location.host +
                  '/white-tower/id/' +
                  props.stoneId +
                  '&hashtags=whitetower,toweroflondon'
                }
                target="_blank"
                rel="noreferrer"
                className="social-icon mr-2"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>

              <a
                href={
                  'https://www.facebook.com/sharer/sharer.php?u=' +
                  window.location.protocol +
                  '//' +
                  window.location.host +
                  '/white-tower/id/' +
                  props.stoneId
                }
                target="_blank"
                rel="noreferrer"
                className="social-icon mr-2"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
            </div>
          </div>

          <div className="mt-auto">
            <div className="row mt-4 mb-4">
              <div className="col-md-6 mb-2 font-weight-bold d-flex flex-column">
                <Link
                  to={'/id/' + props.stoneId}
                  className="btn btn-dark d-flex flex-grow-1 align-items-center justify-content-center"
                >
                  View Stone
                </Link>
              </div>

              <div className="col-md-6 mb-2">
                <PdfButton
                  documentInfo={documentInfo}
                  stoneId={props.stoneId}
                />
              </div>
            </div>

            {props.showEmailForm ? (
              <div className="mb-4">
                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={emailVisibility}
                    id={props.stoneId + '-isGift'}
                    onChange={handleCheckboxChange}
                  />

                  <label
                    className="form-check-label"
                    htmlFor={props.stoneId + '-isGift'}
                  >
                    Please tick the box if this stone is a gift
                  </label>
                </div>

                {emailVisibility ? (
                  <form onSubmit={sendEmail}>
                    <div className="row mx-0 mb-2">
                      <div className="col-sm-9 px-0">
                        <label
                          htmlFor={props.stoneId + '-giftRecipientAddress'}
                        >
                          Enter recipients email address
                        </label>
                      </div>

                      <div className="col-sm-9 px-0">
                        <input
                          type="email"
                          name="giftRecipientAddress"
                          id={props.stoneId + '-giftRecipientAddress'}
                          className="form-control"
                          required={true}
                          ref={emailField}
                        />
                      </div>

                      <div className="col-sm-3 px-0">
                        <button className="btn btn-success d-block w-100">
                          Send
                          <FontAwesomeIcon
                            icon={faChevronRight}
                            className="ml-2"
                          />
                        </button>
                      </div>
                    </div>
                    {emailAlert !== null ? (
                      <div className={`alert alert-${emailAlert.status}`}>
                        {emailAlert.text}
                      </div>
                    ) : null}
                  </form>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
